import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { RestaurantStatus } from 'core/client';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { theme } from 'src/template';
import styled from 'styled-components';
import Opening from './opening';
export function List(_ref) {
  var restaurant = _ref.restaurant,
      distance = _ref.distance,
      onClick = _ref.onClick,
      isFocused = _ref.isFocused;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Container, {
    onClick: onClick,
    className: "".concat(isFocused ? 'focused' : ''),
    children: [restaurant.status === RestaurantStatus.Register && /*#__PURE__*/_jsx("div", {
      className: "upcoming",
      "data-coming": t('restaurant.upcoming')
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("span", {
        className: "restaurantName",
        children: restaurant.name
      }), " ", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("address", {
        className: "restaurantAddress",
        children: [restaurant.address.street, ", ", restaurant.address.zipCode, " ", restaurant.address.city]
      }), /*#__PURE__*/_jsx(Opening, {
        opening: restaurant.pickUp.hours,
        upcoming: restaurant.status === RestaurantStatus.Register
      }), /*#__PURE__*/_jsx(Link, {
        href: "/restaurant/".concat(restaurant.slug),
        prefetch: false,
        children: /*#__PURE__*/_jsx("a", {
          children: t(restaurant.status === RestaurantStatus.Register ? 'restaurant.moreInfo' : 'restaurant.orderHere')
        })
      })]
    }), distance && /*#__PURE__*/_jsxs("div", {
      className: "kmContainer",
      children: [/*#__PURE__*/_jsx("div", {
        className: "divider"
      }), /*#__PURE__*/_jsxs("span", {
        className: "restaurantDistance",
        children: [/*#__PURE__*/_jsx("span", {
          className: "distance",
          children: distance
        }), /*#__PURE__*/_jsx("span", {
          children: "km"
        })]
      })]
    })]
  });
}
var Container = styled.div.withConfig({
  displayName: "list__Container",
  componentId: "sc-m51ggv-0"
})(["align-items:center;background-color:#fff;border-radius:9px;display:flex;justify-content:space-between;margin:20px;padding:24px;position:relative;&.focused{outline:2px solid ", ";}a{font-size:14px;font-weight:700;line-height:17px;text-decoration-line:underline;text-transform:uppercase;}.kmContainer{align-items:center;display:flex;}.divider{border-left:1px solid #333;height:70px;margin:0 10px;width:1px;}.restaurantName{font-size:11.8726px;font-weight:700;line-height:15px;text-transform:uppercase;}.restaurantAddress{font-size:12px;font-weight:300;line-height:15px;margin:0;}.restaurantDistance{display:flex;flex-direction:column;font-size:14px;line-height:16px;}.distance{font-weight:600;}.upcoming{height:80px;overflow:hidden;position:absolute;right:0;top:0;width:80px;&:before,&:after{display:block;height:29.93px;position:absolute;right:-25px;top:10px;transform:rotate(43.4deg);width:106.5px;}&:before{background:url(/image/upcoming-background.png) no-repeat;content:'';}&:after{box-sizing:border-box;color:", ";content:attr(data-coming);font-size:7px;font-weight:580;letter-spacing:0.005em;line-height:10px;padding:4px 32px;text-align:center;text-transform:uppercase;}}"], theme.colors.secondary, theme.colors.secondary);